import React from 'react';
import './Ansprechpartner.css';
import PortraitA from '../assets/PortraitA.jpg';
import PortraitF from '../assets/PortraitF.jpg';
import PortraitK from '../assets/PortraitK.jpg';

const Ansprechpartner: React.FC = () => {
  return (
    <section>
      <div className="container">
        <h2 className="page-heading">Ansprechpartner</h2>
        <div className="team">
          <div className="card">
            <img src={PortraitA} alt="Annika Zöller" className="card-img" />
            <div className="card-info">
              <h3>Annika Zöller</h3>
              <p className="title">Projektmanagerin Kommuale Wärmeplanung</p>
              <p className="email">annika.zoeller@zgt-ingenieure.de</p>
            </div>
          </div>

          <div className="card">
            <img src={PortraitK} alt="Kurt Zügner" className="card-img" />
            <div className="card-info">
              <h3>Kurt Zügner</h3>
              <p className="title">Dipl. Ing (FH)</p>
              <p className="email"></p>
              <p className="email">kurt.zuegner@zgt-ingenieure.de</p>
            </div>
          </div>

          <div className="card">
            <img src={PortraitF} alt="Jane Smith" className="card-img" />
            <div className="card-info">
              <h3>Felix König</h3>
              <p className="title">Technische Büroleitung</p>
              <p className="email"></p>
              <p className="email">felix.koenig@zgt-ingenieure.de</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Ansprechpartner;
